<template>
  <div class="text-black text-19px w-full h-full flex flex-col">
    <div class="pb-20px px-20px flex-1 overflow-hidden flex flex-col">
      <Step class="mb-40px" :steps="steps" v-model="step" />
      <div class="flex-1 overflow-hidden">
        <!-- 基础信息 -->
        <BaseInfo v-show="step === 0" v-model="baseInfo" ref="baseInfoRef" />
        <!-- 关联模型 -->
        <correlationModel v-if="step === 1" :id="modelId" />
      </div>
    </div>
    <div class="footer">
      <div class="flex-1">
        <div class="w-full flex items-center" v-if="step === 1">
          <img src="@/assets/images/warning.png" class="w-27px h-27px" />
          <span class="text-16px text-default">
            <span>若无需关联，可直接点击“完成”</span>
          </span>
        </div>
      </div>
      <el-button plain v-if="step > 0" @click="backStep"
        >上一步</el-button
      >
      <el-button type="primary" @click="saveAndNext" :data-umami-event="step===3?'新建数据集-完成':'新建数据集-保存并下一步'">{{
        step === 1 ? '完成' : '保存并下一步'
      }}</el-button>
    </div>
  </div>
</template>

<script>
import BaseInfo from './base-info.vue'
import correlationModel from '@/views/model/new-model/correlation-model.vue'
import Step from '@/components/step.vue'
import getFullByLastIdFromTree from '@/utils/getFullByLastIdFromTree'
import getNameById from '@/utils/getSelectNameById'
import getOrgEnNameById from '@/utils/getSelectOrgEnNameById'

export default {
  components: { BaseInfo, correlationModel, Step },
  props: {
    edit: {
      default: false
    },
    id: {
      default: ''
    }
  },
  data() {
    return {
      step: 0,
      steps: [
        { iconClass: 'jcxx', name: '基础信息' },
        { iconClass: 'glmx', name: '关联模型' }
      ],
      modelId: '', // 新生成的数据集id
      baseInfo: {},
      nextDisable:false
    }
  },
  watch: {
    edit: {
      handler() {
        this.isEditMode()
      },
      immediate: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    saveAndNext() {
      switch (this.step) {
        case 0:
          // 基础信息
          if(this.nextDisable==true){
            return
          }
          this.$refs['baseInfoRef'].$refs['formRef'].validate((valid) => {
            if (valid) {
              this.nextDisable=true
              console.log('基础信息验证通过')
              this.saveBaseInfo().then((res) => {
                this.nextDisable=false
                if (res.message === 'Success') {
                  if (!this.modelId) {
                    // 新增
                    this.modelId = res.data.id
                  }
                  this.$message.success('保存成功')
                  this.step++
                }
              })
            }
          })
          break
        case 1:
          // 关联模型
          console.log('结束')
          if (this.edit) {
            // 修改
            this.$message.success('保存成功')
          } else {
            // 创建
            this.$message.success('数据集创建成功，请上传相应数据集文件')
          }
          this.$emit('finish', {
            username: getOrgEnNameById(
              this.$store.state.selectOptions.owner,
              this.baseInfo.owner
            ),
            engName: this.baseInfo.engName
          })
          this.resetDefault()
          break
        default:
          break
      }
    },
    backStep(){
      this.step--
      if(this.step===0){
        this.$refs['baseInfoRef'].setDisable()
      }
    },
    setUnDisable(){
      if(this.step===0){
        this.$refs['baseInfoRef'].setUnDisable()
      }
    },
    // 保存基础信息
    saveBaseInfo() {
      const {
        engName, // 英文名
        name, // 中文名
        owner, // 发布者
        protocol, // 协议
        modelType, // 支持模型类型
        applicationScenario, // 应用场景
        language, // 语言
        isOpen, // 是否公开
        customTag, // 自定义标签
        modelProfile // 简介
      } = this.baseInfo

      const data = {
        project_name_en: engName, // 英文名称
        project_name_zh: name, // 中文名称
        project_type: 'D', // M 模型 D数据集
        user_id: owner, // 发布者
        project_license_id: protocol, // 开源协议
        project_category_id: modelType.length > 0 && modelType.slice(-1)[0], // 支持模型类型（取最后一级的id就行）
        sense_ids: applicationScenario, // 应用场景
        language_ids: language, // 语言
        is_public: isOpen, // 是否公开
        label_ids: customTag.map((item) => item.id), // 自定义标签
        project_intro: modelProfile // 模型简介
      }

      if (this.modelId) {
        // 修改
        data.id = this.modelId
      }
      return this.$api.project.addModel(data)
    },
    // 获取数据集信息
    getDatasetInfo(id) {
      this.$api.project
        .queryprojectinfo({
          id
        })
        .then((res) => {
          if (res.message === 'Success') {
            const {
              Id,
              project_name_en: engName, // 英文名
              project_name_zh: name, // 中文名
              user_id: owner, // 发布者
              project_license_id: protocol, // 开源版本协议
              project_category_id, // 支持模型类型
              sense_ids: applicationScenario, // 应用场景
              language_ids: language, // 语言
              is_public: isOpen, // 是否公开
              label_ids, // 自定义标签
              project_intro: modelProfile // 简介
            } = res.data
            let modelType = getFullByLastIdFromTree(
              this.$store.state.selectOptions.modelType,
              project_category_id
            )
            let customTag = label_ids.map((item) => {
              return {
                id: item,
                name: getNameById(this.$store.state.selectOptions.label, item)
              }
            })
            this.baseInfo = {
              id: Id, // id
              engName, // 英文名
              name, // 中文名
              owner, // 发布者
              protocol, // 开源版本协议
              modelType, // 支持模型类型
              applicationScenario, // 应用场景
              language, // 语言
              isOpen, // 是否公开
              customTag, // 自定义标签
              modelProfile // 数据集简介
            }
          }
        })
    },
    // 判断组件是新建还是修改
    isEditMode() {
      console.log('isEditMode')
      if (this.edit) {
        this.modelId = this.id
        this.getDatasetInfo(this.modelId)
      } else {
        this.resetDefault()
      }
    },
    // 恢复组件初始状态
    resetDefault() {
      this.step = 0
      this.modelId = ''
      this.baseInfo = {
        isOpen: 1,
        customTag: []
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.footer {
  height: 60px;
  padding-top: 20px;
  display: flex;
  align-items: center;
  border-top: 1px solid #f4e9ff;
}

::v-deep .el-form {
  .el-form-item {
    &:last-child {
      // 模型简介label垂直位置
      .el-form-item__label {
        align-self: flex-start;
      }
    }
    .el-form-item__label {
      width: 0.8rem;
    }
  }
}

</style>
